var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloatingIpHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.66663H12.845C12.1025 1.66663 11.7308 2.56413 12.2558 3.08913L13.405 4.23829L10.0417 7.60163C8.94001 8.70329 8.33334 10.1683 8.33334 11.7266V14.1666H11.6667V11.7258C11.6667 11.0583 11.9267 10.43 12.3983 9.95746L15.7617 6.59413L16.9108 7.74329C17.4358 8.26913 18.3333 7.89746 18.3333 7.15496V3.33329C18.3333 2.41246 17.5875 1.66663 16.6667 1.66663Z",
    fill: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66666 3.33329V7.15496C1.66666 7.89746 2.56416 8.26913 3.08916 7.74413L4.23837 6.59491L7.60166 9.95746C8.06999 10.4266 8.33332 11.0625 8.33332 11.725V17.5C8.33332 17.96 8.70666 18.3333 9.16666 18.3333H10.8333C11.2933 18.3333 11.6667 17.96 11.6667 17.5V11.7266C11.6667 10.1791 11.0525 8.69579 9.95832 7.60162L6.59499 4.23829L7.74416 3.08913C8.26916 2.56413 7.89749 1.66663 7.15499 1.66663H3.33332C2.41249 1.66663 1.66666 2.41246 1.66666 3.33329Z",
    fill: "url(#paint0_linear_71_1418)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_1418",
    x1: 2,
    y1: 1.99997,
    x2: 11.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_1418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingIpHover);
export default __webpack_public_path__ + "static/media/floating-ip-hover.036ed147707cb35b400ae9a93bf9a438.svg";
export { ForwardRef as ReactComponent };